import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { Modal as ModalComp } from '@insurancemenu/imenu-components-lib/dist/components';
import styled from 'styled-components';

export const EmployersModalStyled = styled(ModalComp)`
  max-width: 110rem;
  min-height: 55vh;
  padding: 4rem 2.4rem;
`;

export const ModalTitleStyled = styled.h2`
  ${typography.bold[24]}
  text-align: center;
  margin: 0 0 2rem;
`;

export const ModalSubtitleStyled = styled.p`
  ${typography.regular[18]}
  color: ${colors.neutral[700]};
  text-align: center;
  margin: 0 0 3rem;
`;

export const ModalContentWrapperStyled = styled.div`
  position: relative;
`;

export const NoDataMessageStyled = styled.p`
  margin: 4rem 0;
  color: ${colors.neutral[900]};
  ${typography.bold[18]}
  text-align: center;
`;

export const EmployersSectionStyled = styled.div`
  margin: 0 0 4rem;
  width: 100%;
`;

export const ModalFooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  padding: 3rem 0;
`;
